import { SharedErrors } from 'web_core_library';
import { WorkoutUnityResult } from 'web_unity_engine';

// currently available achivements in the mobile app
export enum EAchievementType {
  Unknown = -1,
  GoalReached = 1, // multi
  AccuracyPerfect = 2, // multi
  NewLevelUnlocked = 3, // single
  HistogramPercentage = 4, // single
  PlayTimes = 5, // single
  HighScore = 6, // multi
  Streak = 7, // multi - experiment failed, no new achievement will be detected
  // global achievements starts from here:
  WorkoutNumber = 8, // single
  PlayTimeLength = 9, // single
  FinishedSessions = 10, // single
  GoalReachedTimes = 11, // single
  AccuracyPerfectAgg = 12, // single
  HistogramPercentage90p = 13, // single
  HistogramPercentage50p = 14, // single
}

export type TGlobalAchievements =
  | EAchievementType.WorkoutNumber
  | EAchievementType.PlayTimeLength
  | EAchievementType.FinishedSessions
  | EAchievementType.GoalReachedTimes
  | EAchievementType.AccuracyPerfectAgg
  | EAchievementType.HistogramPercentage90p
  | EAchievementType.HistogramPercentage50p;

export enum EAchievementsIntencity {
  Good = 'Good',
  Great = 'Great',
  Outstanding = 'Outstanding',
}

// achievement data structure stored and fetched from backend
export interface IAchievementData {
  workoutId: number;
  type: EAchievementType;
  subType: number;
  timestamp: number;
}

// achievement data stored and used on frontend
export interface IAchievement extends IAchievementData {
  // synchronization timestamp = 0 if not synchronized with backend
  syncTimestamp: number;
}

// narrow down general achievement to "global" achievement type
export interface IGlobalAchievement extends IAchievement {
  workoutId: 0;
  type: TGlobalAchievements;
}

// full achievements payload received from api
export interface IFullAchievementsData {
  single: IAchievementData[];
  multi: IAchievementData[];
}

// partial achievements payload accepted by saving api endpoint
export type PartialAchievementsData = Partial<IFullAchievementsData>;

export interface IAchievementsData {
  single: IAchievement[];
  multi: IAchievement[];
}

export interface IAchievementsDataCache {
  achievements: IAchievementsData;
  timestamp: number;
}

export class AchievementsError extends SharedErrors.BaseError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, AchievementsError.prototype);
    this.feature = 'Achievements';
  }
}

export class AchievementsCacheError extends AchievementsError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, AchievementsCacheError.prototype);
    this.feature = 'Achievements_cache';
  }
}

export interface IDetectAchievementsPayload {
  workoutId: number;
  exerciseId: string;
  siblings: number[];
  progress: WorkoutUnityResult;
  maxDifficulty: number;
  comparison: number;
  totalGameplays: number;
  goal: number;
  bestResult?: number;
}

export interface IAchievementsGlobalStatsPayload {
  currentCycleId: number;
  currentSessionId: number;
  cycleLength: number;
  finishedCycles: number;
  finishedSessions: number;
  numberWorkouts: number;
}
